// /** 全局变量 */
interface IGlobalData {
  [key: string]: any
}

// declare const GLOBAL_DATA: GlobalData;
/** 全局变量 */
const GLOBAL_DATA: IGlobalData = {}

/**
 * 设置全局变量
 * @param {*} key
 * @param {*} data
 */
export function setGlobalData(key: string, data: any): void {
  GLOBAL_DATA[key] = data
}

/**
 * 获取全局变量的值
 * @param {*} key
 * @returns
 */
export function getGlobalData(key: string): string {
  return GLOBAL_DATA[key]
}
